var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      key: _vm.curKey,
      attrs: {
        width: "400",
        right: "",
        temporary: "",
        fixed: "",
        "overlay-opacity": 0,
      },
      on: { input: _vm.onChange },
      model: {
        value: _vm.drawer,
        callback: function ($$v) {
          _vm.drawer = $$v
        },
        expression: "drawer",
      },
    },
    [
      _c(
        "v-container",
        {
          staticClass:
            "\n      d-flex\n      flex-column\n      justify-space-around\n      pa-0\n      pb-0\n      mrc-grey\n      fill-height\n    ",
          attrs: { fluid: "" },
        },
        [
          _c(
            "v-toolbar",
            {
              staticClass: "pr-3",
              staticStyle: { width: "100%" },
              attrs: { flat: "", dense: "", color: "primary", height: "48" },
            },
            [
              _c(
                "v-toolbar-title",
                { staticClass: "text-subtitle-2" },
                [
                  _c(
                    "v-list-item-title",
                    { staticClass: "table-subttile white--text" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.Data
                              ? _vm.$getCommonLangValue(
                                  _vm.Data["preferred_name"]
                                )
                              : ""
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "v-list-item-subtitle",
                    { staticClass: "table-subttile white--text" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.curData ? _vm.curData["roster_date"] : ""
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-menu",
                {
                  attrs: { "offset-x": "", left: "", "min-width": "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.iSEdited,
                                      expression: "!iSEdited",
                                    },
                                  ],
                                  staticClass: "mr-2",
                                  attrs: {
                                    icon: "",
                                    color: "white",
                                    small: "",
                                  },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _c(
                                "span",
                                { staticClass: "material-icons-round" },
                                [_vm._v("edit")]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-item",
                        { on: { click: _vm.toChangeRecord } },
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_RosterFormRecord_form_slide_modifyAttenndanceRecordLabel"
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              {
                                attrs: { icon: "", color: "white", small: "" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.closeDialog.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              on
                            ),
                            [
                              _c(
                                "span",
                                { staticClass: "material-icons-round" },
                                [_vm._v("close")]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "label_essweb_RosterFormRecord_form_slide_closeBtnTip"
                        )
                      )
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "v-container",
            {
              staticClass: "pa-3 mrc-grey scroll_content_y",
              style: {
                height: _vm.iSEdited
                  ? "calc(100% - 96px)"
                  : "calc(100% - 48px)",
              },
              attrs: { fluid: "" },
            },
            [
              !_vm.Data ? _c("noContent") : _vm._e(),
              _vm.Data
                ? _c(
                    "v-container",
                    {
                      staticClass: "justify-start pa-0 transparent",
                      attrs: { fluid: "" },
                    },
                    [
                      _c(
                        "v-sheet",
                        {
                          staticClass:
                            "\n            d-flex\n            flex-row\n            justify-space-around\n            transparent\n            align-center\n          ",
                          attrs: { width: "100%" },
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass: "transparent",
                              attrs: { "min-width": "80%" },
                            },
                            [
                              Number(_vm.Data["is_late"])
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 white--text",
                                      attrs: {
                                        small: "",
                                        color: _vm.$getTagColors(
                                          _vm.$card_line_colors,
                                          "is_late_1"
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_system_tag_label_lateLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              Number(_vm.Data["is_ot"])
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 white--text",
                                      attrs: {
                                        small: "",
                                        color: _vm.$getTagColors(
                                          _vm.$card_line_colors,
                                          "is_ot_1"
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_system_tag_label_otLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              Number(_vm.Data["is_missing_punch"])
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 white--text",
                                      attrs: {
                                        small: "",
                                        color: _vm.$getTagColors(
                                          _vm.$card_line_colors,
                                          "is_missing_punch_1"
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_system_tag_label_isMissingPunchLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              Number(_vm.Data["is_adhoc"])
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 text--primary",
                                      attrs: {
                                        small: "",
                                        color: _vm.$getTagColors(
                                          _vm.$card_line_colors,
                                          "is_adhoc_1"
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_system_tag_label_isAdhocLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              Number(_vm.Data["is_on_leave"])
                                ? _vm._l(
                                    _vm.Data.leave_info,
                                    function (leave, index) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: "leave--" + index,
                                          staticClass: "ma-1",
                                          attrs: {
                                            small: "",
                                            outlined: "",
                                            color: leave.color_code,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$getCommonLangValue(
                                                leave["leave_type_name"]
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    }
                                  )
                                : _vm._e(),
                              Number(_vm.Data["holiday_info"])
                                ? _vm._l(
                                    _vm.Data["holiday_info"],
                                    function (holiday, index) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: "holiday--" + index,
                                          staticClass: "ma-1 text--primary",
                                          attrs: {
                                            small: "",
                                            color: _vm.$getTagColors(
                                              _vm.$card_line_colors,
                                              "is_holiday_1"
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$getCommonLangValue(
                                                holiday["holiday_name"]
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    }
                                  )
                                : _vm._e(),
                              Number(_vm.Data["is_onDuty"])
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 white--text",
                                      attrs: {
                                        small: "",
                                        color: _vm.$getTagColors(
                                          _vm.$card_line_colors,
                                          "is_on_duty_1"
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_system_tag_label_isOnDutyLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              Number(_vm.Data["is_early_leave"])
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 white--text",
                                      attrs: {
                                        small: "",
                                        color: _vm.$getTagColors(
                                          _vm.$card_line_colors,
                                          "is_early_leave_1"
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_system_tag_label_earlyLeaveLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              Number(_vm.Data["is_absense"])
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 white--text",
                                      attrs: {
                                        small: "",
                                        color: _vm.$getTagColors(
                                          _vm.$card_line_colors,
                                          "is_absense_1"
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_system_tag_label_absenseLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              Number(_vm.Data["is_work_from_home"])
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 text--primary",
                                      attrs: {
                                        small: "",
                                        color: _vm.$getTagColors(
                                          _vm.$card_line_colors,
                                          "is_work_from_home_1"
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_punchRecord_list_tag_workFromHomeLabbel"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              Number(_vm.Data["is_out_of_office"])
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 text--primary",
                                      attrs: {
                                        small: "",
                                        color: _vm.$getTagColors(
                                          _vm.$card_line_colors,
                                          "is_out_of_office_1"
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_system_tag_label_isOutOfOfficeLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _c("v-spacer"),
                          Number(_vm.Data["is_locked"])
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_locked_1"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons-round" },
                                    [_vm._v("lock")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-sheet",
                        {
                          staticClass: "pa-2 rounded-xl panel_right mt-4 mb-4",
                          attrs: { width: "100%", elevation: "0" },
                        },
                        [
                          _c("Taber", {
                            attrs: {
                              curTab: _vm.curTab,
                              items: _vm.taber,
                              special: "",
                              backgroundColor: "white",
                              centered: false,
                              grow: false,
                            },
                            on: {
                              change: function (tab) {
                                return (_vm.curTab = tab)
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "content-1",
                                  fn: function () {
                                    return [
                                      _c(
                                        "v-form",
                                        {
                                          ref: "recordform",
                                          staticClass: "max-width",
                                          class: _vm.iSEdited ? "px-0" : "px-3",
                                          attrs: { "lazy-validation": "" },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass:
                                                "max-width mx-0 py-3",
                                              attrs: { align: "center" },
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 5
                                                        : 7,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalWorkingLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "text-center",
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 7
                                                        : 5,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    [
                                                      !(
                                                        _vm.iSEdited &&
                                                        Number(
                                                          _vm.Data[
                                                            "is_allow_modify_attendance_total"
                                                          ]
                                                        ) == 1
                                                      )
                                                        ? _c("span", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$timeMachine(
                                                                    _vm.Data[
                                                                      "official_working_minutes"
                                                                    ] || 0,
                                                                    false
                                                                  )
                                                                )
                                                            ),
                                                          ])
                                                        : _c(
                                                            "TimePickerSheet",
                                                            {
                                                              attrs: {
                                                                isRequire: "",
                                                                format: "",
                                                                height: 25,
                                                                hideDetail: "",
                                                                showLabel: false,
                                                                value:
                                                                  _vm.Data
                                                                    .modified_working_minutes,
                                                                defaultTime:
                                                                  _vm.Data
                                                                    .modified_working_minutes,
                                                                placeholder:
                                                                  "00:00",
                                                                label: _vm.$t(
                                                                  "label_essweb_attendanceModifiApp_form_totalWorkingLabel"
                                                                ),
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    time
                                                                  ) {
                                                                    _vm.Data.modified_working_minutes =
                                                                      time
                                                                  },
                                                              },
                                                            }
                                                          ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 5
                                                        : 7,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalBreakMinutesLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "text-center",
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 7
                                                        : 5,
                                                  },
                                                },
                                                [
                                                  !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$timeMachine(
                                                                _vm.Data[
                                                                  "official_break_minutes"
                                                                ] || 0,
                                                                false
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : _c("TimePickerSheet", {
                                                        attrs: {
                                                          isRequire: "",
                                                          format: "",
                                                          height: 25,
                                                          hideDetail: "",
                                                          showLabel: false,
                                                          value:
                                                            _vm.Data
                                                              .modified_break_minutes,
                                                          defaultTime:
                                                            _vm.Data
                                                              .modified_break_minutes,
                                                          placeholder: "00:00",
                                                          label: _vm.$t(
                                                            "label_essweb_attendanceModifiApp_form_totalBreakMinutesLabel"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            time
                                                          ) {
                                                            _vm.Data.modified_break_minutes =
                                                              time
                                                          },
                                                        },
                                                      }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 5
                                                        : 7,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalMealMinutes"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "text-center",
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 7
                                                        : 5,
                                                  },
                                                },
                                                [
                                                  !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$timeMachine(
                                                                _vm.Data[
                                                                  "official_meal_minutes"
                                                                ] || 0,
                                                                false
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : _c("TimePickerSheet", {
                                                        attrs: {
                                                          isRequire: "",
                                                          format: "",
                                                          height: 25,
                                                          hideDetail: "",
                                                          showLabel: false,
                                                          value:
                                                            _vm.Data
                                                              .modified_meal_mintues,
                                                          defaultTime:
                                                            _vm.Data
                                                              .modified_meal_mintues,
                                                          placeholder: "00:00",
                                                          label: _vm.$t(
                                                            "label_essweb_attendanceModifiApp_form_totalMealMinutes"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            time
                                                          ) {
                                                            _vm.Data.modified_meal_mintues =
                                                              time
                                                          },
                                                        },
                                                      }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 5
                                                        : 7,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalOTLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "text-center",
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 7
                                                        : 5,
                                                  },
                                                },
                                                [
                                                  !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$timeMachine(
                                                                _vm.Data[
                                                                  "official_total_ot_minutes"
                                                                ] || 0,
                                                                false
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : _c("TimePickerSheet", {
                                                        attrs: {
                                                          isRequire: "",
                                                          format: "",
                                                          height: 25,
                                                          hideDetail: "",
                                                          showLabel: false,
                                                          value:
                                                            _vm.Data
                                                              .modified_ot_minutes,
                                                          defaultTime:
                                                            _vm.Data
                                                              .modified_ot_minutes,
                                                          placeholder: "00:00",
                                                          label: _vm.$t(
                                                            "label_essweb_attendanceModifiApp_form_totalOTLabel"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            time
                                                          ) {
                                                            _vm.Data.modified_ot_minutes =
                                                              time
                                                          },
                                                        },
                                                      }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 5
                                                        : 7,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalLateLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "text-center",
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 7
                                                        : 5,
                                                  },
                                                },
                                                [
                                                  !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$timeMachine(
                                                                _vm.Data[
                                                                  "official_total_late_minutes"
                                                                ] || 0,
                                                                false
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : _c("TimePickerSheet", {
                                                        attrs: {
                                                          isRequire: "",
                                                          format: "",
                                                          height: 25,
                                                          hideDetail: "",
                                                          showLabel: false,
                                                          value:
                                                            _vm.Data
                                                              .modified_late_minutes,
                                                          defaultTime:
                                                            _vm.Data
                                                              .modified_late_minutes,
                                                          placeholder: "00:00",
                                                          label: _vm.$t(
                                                            "label_essweb_attendanceModifiApp_form_totalLateLabel"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            time
                                                          ) {
                                                            _vm.Data.modified_late_minutes =
                                                              time
                                                          },
                                                        },
                                                      }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 5
                                                        : 7,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalEarlyLeaveLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "text-center",
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 7
                                                        : 5,
                                                  },
                                                },
                                                [
                                                  !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$timeMachine(
                                                                _vm.Data[
                                                                  "official_total_early_leave_minutes"
                                                                ] || 0,
                                                                false
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : _c("TimePickerSheet", {
                                                        attrs: {
                                                          isRequire: "",
                                                          format: "",
                                                          height: 25,
                                                          hideDetail: "",
                                                          showLabel: false,
                                                          value:
                                                            _vm.Data
                                                              .modified_early_leave_minutes,
                                                          defaultTime:
                                                            _vm.Data
                                                              .modified_early_leave_minutes,
                                                          placeholder: "00:00",
                                                          label: _vm.$t(
                                                            "label_essweb_attendanceModifiApp_form_totalEarlyLeaveLabel"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            time
                                                          ) {
                                                            _vm.Data.modified_early_leave_minutes =
                                                              time
                                                          },
                                                        },
                                                      }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 5
                                                        : 7,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalLeaveLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "text-center",
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 7
                                                        : 5,
                                                  },
                                                },
                                                [
                                                  !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$timeMachine(
                                                                _vm.Data[
                                                                  "official_total_leave_minutes"
                                                                ] || 0,
                                                                false
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : _c("TimePickerSheet", {
                                                        attrs: {
                                                          isRequire: "",
                                                          format: "",
                                                          height: 25,
                                                          hideDetail: "",
                                                          showLabel: false,
                                                          value:
                                                            _vm.Data
                                                              .modified_leave_minutes,
                                                          defaultTime:
                                                            _vm.Data
                                                              .modified_leave_minutes,
                                                          placeholder: "00:00",
                                                          label: _vm.$t(
                                                            "label_essweb_attendanceModifiApp_form_totalLeaveLabel"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            time
                                                          ) {
                                                            _vm.Data.modified_leave_minutes =
                                                              time
                                                          },
                                                        },
                                                      }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 5
                                                        : 7,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalAbsenseLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "text-center",
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 7
                                                        : 5,
                                                  },
                                                },
                                                [
                                                  !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$timeMachine(
                                                                _vm.Data[
                                                                  "official_absense_minutes"
                                                                ] || 0,
                                                                false
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : _c("TimePickerSheet", {
                                                        attrs: {
                                                          isRequire: "",
                                                          format: "",
                                                          height: 25,
                                                          hideDetail: "",
                                                          showLabel: false,
                                                          value:
                                                            _vm.Data
                                                              .modified_absense_minutes,
                                                          defaultTime:
                                                            _vm.Data
                                                              .modified_absense_minutes,
                                                          placeholder: "00:00",
                                                          label: _vm.$t(
                                                            "label_essweb_attendanceModifiApp_form_totalAbsenseLabel"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            time
                                                          ) {
                                                            _vm.Data.modified_absense_minutes =
                                                              time
                                                          },
                                                        },
                                                      }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 5
                                                        : 7,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalBeforeWorkLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "text-center",
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 7
                                                        : 5,
                                                  },
                                                },
                                                [
                                                  !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$timeMachine(
                                                                _vm.Data[
                                                                  "official_before_work_minutes"
                                                                ] || 0,
                                                                false
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : _c("TimePickerSheet", {
                                                        attrs: {
                                                          isRequire: "",
                                                          format: "",
                                                          height: 25,
                                                          hideDetail: "",
                                                          showLabel: false,
                                                          value:
                                                            _vm.Data
                                                              .modified_before_work_minutes,
                                                          defaultTime:
                                                            _vm.Data
                                                              .modified_before_work_minutes,
                                                          placeholder: "00:00",
                                                          label: _vm.$t(
                                                            "label_essweb_attendanceModifiApp_form_totalBeforeWorkLabel"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            time
                                                          ) {
                                                            _vm.Data.modified_before_work_minutes =
                                                              time
                                                          },
                                                        },
                                                      }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 5
                                                        : 7,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalAfterWorkLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "text-center",
                                                  class: !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? "pa-0"
                                                    : "pt-1 ",
                                                  attrs: {
                                                    md:
                                                      _vm.iSEdited &&
                                                      Number(
                                                        _vm.Data[
                                                          "is_allow_modify_attendance_total"
                                                        ]
                                                      ) == 1
                                                        ? 7
                                                        : 5,
                                                  },
                                                },
                                                [
                                                  !(
                                                    _vm.iSEdited &&
                                                    Number(
                                                      _vm.Data[
                                                        "is_allow_modify_attendance_total"
                                                      ]
                                                    ) == 1
                                                  )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$timeMachine(
                                                                _vm.Data[
                                                                  "official_after_work_minutes"
                                                                ] || 0,
                                                                false
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ])
                                                    : _c("TimePickerSheet", {
                                                        attrs: {
                                                          isRequire: "",
                                                          format: "",
                                                          height: 25,
                                                          hideDetail: "",
                                                          showLabel: false,
                                                          value:
                                                            _vm.Data
                                                              .modified_after_work_minutes,
                                                          defaultTime:
                                                            _vm.Data
                                                              .modified_after_work_minutes,
                                                          placeholder: "00:00",
                                                          label: _vm.$t(
                                                            "label_essweb_attendanceModifiApp_form_totalAfterWorkLabel"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            time
                                                          ) {
                                                            _vm.Data.modified_after_work_minutes =
                                                              time
                                                          },
                                                        },
                                                      }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "content-2",
                                  fn: function () {
                                    return [
                                      _c("div", { staticClass: "px-3" }, [
                                        _c(
                                          "div",
                                          { staticClass: "d-flex flex-row" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 text--primary",
                                                staticStyle: { width: "50%" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "label_essweb_attendanceModifiApp_form_totalWorkingLabel"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center flex-grow-1",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$timeMachine(
                                                        _vm.Data[
                                                          "actual_working_minutes"
                                                        ] || 0,
                                                        false
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex flex-row" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 text--primary",
                                                staticStyle: { width: "50%" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "label_essweb_attendanceModifiApp_form_totalBreakMinutesLabel"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center flex-grow-1",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$timeMachine(
                                                        _vm.Data[
                                                          "actual_break_minutes"
                                                        ] || 0,
                                                        false
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex flex-row" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 text--primary",
                                                staticStyle: { width: "50%" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "label_essweb_attendanceModifiApp_form_totalMealMinutes"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center flex-grow-1",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$timeMachine(
                                                        _vm.Data[
                                                          "actual_meal_minutes"
                                                        ] || 0,
                                                        false
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex flex-row" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 text--primary",
                                                staticStyle: { width: "50%" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "label_essweb_attendanceModifiApp_form_totalOTLabel"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center flex-grow-1",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$timeMachine(
                                                        _vm.Data[
                                                          "actual_ot_minutes"
                                                        ] || 0,
                                                        false
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex flex-row" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 text--primary",
                                                staticStyle: { width: "50%" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "label_essweb_attendanceModifiApp_form_totalLateLabel"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center flex-grow-1",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$timeMachine(
                                                        _vm.Data[
                                                          "actual_late_minutes"
                                                        ] || 0,
                                                        false
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex flex-row" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 text--primary",
                                                staticStyle: { width: "50%" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "label_essweb_attendanceModifiApp_form_totalEarlyLeaveLabel"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center flex-grow-1",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$timeMachine(
                                                        _vm.Data[
                                                          "actual_early_leave_minutes"
                                                        ] || 0,
                                                        false
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex flex-row" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 text--primary",
                                                staticStyle: { width: "50%" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "label_essweb_attendanceModifiApp_form_totalLeaveLabel"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center flex-grow-1",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$timeMachine(
                                                        _vm.Data[
                                                          "actual_leave_minutes"
                                                        ] || 0,
                                                        false
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex flex-row" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 text--primary",
                                                staticStyle: { width: "50%" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "label_essweb_attendanceModifiApp_form_totalAbsenseLabel"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center flex-grow-1",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$timeMachine(
                                                        _vm.Data[
                                                          "actual_absense_minutes"
                                                        ] || 0,
                                                        false
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex flex-row" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 text--primary",
                                                staticStyle: { width: "50%" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "label_essweb_attendanceModifiApp_form_totalBeforeWorkLabel"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center flex-grow-1",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$timeMachine(
                                                        _vm.Data[
                                                          "actual_before_work_minutes"
                                                        ] || 0,
                                                        false
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex flex-row" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 text--primary",
                                                staticStyle: { width: "50%" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "label_essweb_attendanceModifiApp_form_totalAfterWorkLabel"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center flex-grow-1",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$timeMachine(
                                                        _vm.Data[
                                                          "actual_after_work_minutes"
                                                        ] || 0,
                                                        false
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              523446634
                            ),
                          }),
                        ],
                        1
                      ),
                      _c("v-sheet", {
                        staticClass: "mt-8 mb-8",
                        attrs: {
                          height: "1",
                          width: "100%",
                          color: "grey lighten-2",
                        },
                      }),
                      _c(
                        "v-sheet",
                        {
                          staticClass: "rounded-xl pa-3 mt-4",
                          staticStyle: { overflow: "hidden" },
                          attrs: { width: "100%", elevation: "0" },
                        },
                        [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "d-flex flex-row justify-space-between",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "text-center",
                                  staticStyle: { width: "24px" },
                                },
                                [
                                  _c("svg-icon", {
                                    attrs: {
                                      size: "24",
                                      fill: _vm.Data[
                                        "official_shift_color_code"
                                      ],
                                      iconClass: "LabeledColour",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "pl-1",
                                  staticStyle: {
                                    "max-width": "calc(100% - 120px)",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          _vm.Data["official_shift_name"]
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("v-spacer"),
                              _c(
                                "div",
                                {
                                  staticClass: "text--secondary",
                                  staticStyle: { "max-width": "100px" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getDateTime(
                                          _vm.Data["official_start_utc_time"],
                                          "HH:mm"
                                        ) +
                                          " - " +
                                          _vm.$getDateTime(
                                            _vm.Data["official_end_utc_time"],
                                            "HH:mm"
                                          )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.Data["site_name"]
                            ? _c(
                                "v-sheet",
                                {
                                  staticClass: "d-flex flex-row justify-start",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-center",
                                      staticStyle: { width: "24px" },
                                    },
                                    [
                                      _c("svg-icon", {
                                        attrs: {
                                          size: "16",
                                          fill: "grey",
                                          iconClass: "site",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "pl-1 text--secondary" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              _vm.Data["site_name"]
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.Data["cost_center_name"]
                            ? _c(
                                "v-sheet",
                                {
                                  staticClass: "d-flex flex-row justify-start",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-center",
                                      staticStyle: { width: "24px" },
                                    },
                                    [
                                      _c("svg-icon", {
                                        attrs: {
                                          size: "16",
                                          fill: "grey",
                                          iconClass: "cost_center",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "pl-1 text--secondary" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              _vm.Data["cost_center_name"]
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.Data["leave_type_remark_name"]
                            ? _c(
                                "v-sheet",
                                {
                                  staticClass: "d-flex flex-row justify-start",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-center",
                                      staticStyle: { width: "24px" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "material-icons-round text--secondary",
                                        },
                                        [_vm._v("today")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "pl-1 text--secondary" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              _vm.Data["leave_type_remark_name"]
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.Data["remarks"]
                            ? _c(
                                "v-sheet",
                                {
                                  staticClass: "d-flex flex-row justify-start",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-center flex-shrink-1",
                                      staticStyle: { width: "24px" },
                                    },
                                    [
                                      _c("svg-icon", {
                                        attrs: {
                                          size: "16",
                                          fill: "rgba(0, 0, 0, 0.54)",
                                          iconClass: "mini_doc",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pl-1 text--secondary text-ellipsis-2",
                                      staticStyle: {
                                        width: "calc(100% - 24px)",
                                      },
                                      attrs: { title: _vm.Data["remarks"] },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.Data["remarks"]) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-sheet",
                        {
                          staticClass: "rounded-xl d-flex mt-4 flex-column",
                          attrs: { elevation: "0", width: "100%" },
                        },
                        _vm._l(
                          _vm.Data["ess_att_attendance_detail"],
                          function (item, index) {
                            return _c(
                              "v-sheet",
                              { key: "detail" + index, staticClass: "ma-4" },
                              [
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass: "text-subtitle-2",
                                    staticStyle: { width: "100%" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          item.event_type_name
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass:
                                      "d-flex flex-row justify-start mt-2",
                                  },
                                  [
                                    _c("v-sheet", {
                                      attrs: {
                                        width: "8",
                                        height: "auto",
                                        color:
                                          "primary lighten-4 rounded-xl mr-2",
                                      },
                                    }),
                                    _c("v-sheet", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-subtitle-2 text--secondary",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_attendanceModifiApp_form_scheduleShiftTimeLabel"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "text-subtitle-2" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getDateTime(
                                                  item.schedule_start_utc_time,
                                                  "HH:mm"
                                                ) +
                                                  " - " +
                                                  _vm.$getDateTime(
                                                    item.schedule_end_utc_time,
                                                    "HH:mm"
                                                  )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass:
                                      "d-flex flex-row justify-start mt-2",
                                  },
                                  [
                                    _c("v-sheet", {
                                      attrs: {
                                        width: "8",
                                        height: "auto",
                                        color:
                                          "primary lighten-2 rounded-xl mr-2",
                                      },
                                    }),
                                    _c("v-sheet", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-subtitle-2 text--secondary",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_attendanceModifiApp_form_officialShiftTimeLabel"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "text-subtitle-2" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getDateTime(
                                                  item.official_start_utc_time,
                                                  "HH:mm"
                                                ) +
                                                  " - " +
                                                  _vm.$getDateTime(
                                                    item.official_end_utc_time,
                                                    "HH:mm"
                                                  )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass:
                                      "d-flex flex-row justify-start mt-2",
                                  },
                                  [
                                    _c("v-sheet", {
                                      attrs: {
                                        width: "8",
                                        height: "auto",
                                        color: "primary base rounded-xl mr-2",
                                      },
                                    }),
                                    _c(
                                      "v-sheet",
                                      { attrs: { width: "100%" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-subtitle-2 text--secondary",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_attendanceModifiApp_form_actualPunchTime"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "\n                    d-flex\n                    flex-row\n                    justify-space-between\n                    flex-grow-1\n                    mt-2\n                  ",
                                            staticStyle: { width: "100%" },
                                          },
                                          [
                                            _c(
                                              "v-sheet",
                                              {
                                                attrs: {
                                                  color:
                                                    "grey lighten-3 text-subtitle-2 text-center rounded",
                                                  width: "50%",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$getDateTime(
                                                        item.actual_punch_in_utc_datetime,
                                                        "HH:mm"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-center",
                                                staticStyle: { width: "20px" },
                                              },
                                              [_vm._v("-")]
                                            ),
                                            _c(
                                              "v-sheet",
                                              {
                                                attrs: {
                                                  color:
                                                    "grey lighten-3 text-subtitle-2 text-center rounded",
                                                  width: "50%",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$getDateTime(
                                                        item.actual_punch_out_utc_datetime,
                                                        "HH:mm"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm.iSEdited
                                  ? _c(
                                      "v-sheet",
                                      {
                                        staticClass:
                                          "d-flex flex-row justify-start mt-2",
                                      },
                                      [
                                        _c("v-sheet", {
                                          attrs: {
                                            width: "8",
                                            height: "auto",
                                            color: "primary rounded-xl mr-2",
                                          },
                                        }),
                                        _c(
                                          "v-sheet",
                                          { attrs: { width: "100%" } },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 text--secondary",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "label_essweb_attendanceModifiApp_form_modifilyOfficialPunchTime"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "\n                    d-flex\n                    flex-row\n                    justify-space-between\n                    flex-grow-1\n                    mt-2\n                  ",
                                                staticStyle: { width: "100%" },
                                              },
                                              [
                                                _c(
                                                  "v-sheet",
                                                  {
                                                    attrs: {
                                                      color:
                                                        "grey lighten-3 text-subtitle-2 text-center rounded",
                                                      width: "50%",
                                                    },
                                                  },
                                                  [
                                                    !Number(
                                                      item.is_punch_in_required
                                                    )
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$getDateTime(
                                                                  item.modified_punch_in_utc_datetime_save,
                                                                  "HH:mm"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.iSEdited &&
                                                    Number(
                                                      item.is_punch_in_required
                                                    )
                                                      ? _c("TimePickerSheet", {
                                                          attrs: {
                                                            isRequire: "",
                                                            hideDetail: "",
                                                            show48: 23,
                                                            showDay: "",
                                                            showLabel: false,
                                                            max: item.modified_punch_out_utc_datetime,
                                                            value:
                                                              item.modified_punch_in_utc_datetime,
                                                            defaultTime:
                                                              item.modified_punch_in_utc_datetime,
                                                            placeholder:
                                                              "--:--",
                                                          },
                                                          on: {
                                                            modify: function (
                                                              $event
                                                            ) {
                                                              item.is_change_modified_punch_in_utc_datetime = true
                                                            },
                                                            change: function (
                                                              time
                                                            ) {
                                                              item.modified_punch_in_utc_datetime =
                                                                time
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-center",
                                                    staticStyle: {
                                                      width: "20px",
                                                    },
                                                  },
                                                  [_vm._v("-")]
                                                ),
                                                _c(
                                                  "v-sheet",
                                                  {
                                                    attrs: {
                                                      color:
                                                        "grey lighten-3 text-subtitle-2 text-center rounded",
                                                      width: "50%",
                                                    },
                                                  },
                                                  [
                                                    !Number(
                                                      item.is_punch_out_required
                                                    )
                                                      ? _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$getDateTime(
                                                                  item.modified_punch_out_utc_datetime_save,
                                                                  "HH:mm"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.iSEdited &&
                                                    Number(
                                                      item.is_punch_out_required
                                                    )
                                                      ? _c("TimePickerSheet", {
                                                          attrs: {
                                                            isEnd: "",
                                                            show48: 23,
                                                            isRequire: "",
                                                            showDay: "",
                                                            hideDetail: "",
                                                            showLabel: false,
                                                            min: item.modified_punch_in_utc_datetime,
                                                            value:
                                                              item.modified_punch_out_utc_datetime,
                                                            defaultTime:
                                                              item.modified_punch_out_utc_datetime,
                                                            placeholder:
                                                              "__:__",
                                                          },
                                                          on: {
                                                            modify: function (
                                                              $event
                                                            ) {
                                                              item.is_change_modified_punch_out_utc_datetime = true
                                                            },
                                                            change: function (
                                                              time
                                                            ) {
                                                              item.modified_punch_out_utc_datetime =
                                                                time
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass:
                                      "d-flex flex-row justify-start mt-2",
                                  },
                                  [
                                    _c("v-sheet", {
                                      attrs: {
                                        width: "8",
                                        height: "auto",
                                        color: "primary rounded-xl mr-2",
                                      },
                                    }),
                                    _c(
                                      "v-sheet",
                                      { attrs: { width: "100%" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-subtitle-2 text--secondary",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_attendanceModifiApp_form_officialPunchTime"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "\n                    d-flex\n                    flex-row\n                    justify-space-between\n                    flex-grow-1\n                    mt-2\n                  ",
                                            staticStyle: { width: "100%" },
                                          },
                                          [
                                            _c(
                                              "v-sheet",
                                              {
                                                attrs: {
                                                  color:
                                                    "grey lighten-3 text-subtitle-2 text-center rounded",
                                                  width: "50%",
                                                  title: _vm.$getDateTime(
                                                    item.official_punch_in_utc_datetime_save,
                                                    "YYYY/MM/DD HH:mm"
                                                  ),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      Math.floor(
                                                        Math.abs(
                                                          item[
                                                            "official_punch_in_utc_datetime_save_minutes"
                                                          ]
                                                        ) / 1440
                                                      ) == 0
                                                        ? ""
                                                        : item[
                                                            "official_punch_in_utc_datetime_save_minutes"
                                                          ]
                                                        ? item[
                                                            "official_punch_in_utc_datetime_save_minutes"
                                                          ] > 0
                                                          ? "(+" +
                                                            Math.floor(
                                                              Math.abs(
                                                                item[
                                                                  "official_punch_in_utc_datetime_save_minutes"
                                                                ]
                                                              ) / 1440
                                                            ) +
                                                            ")"
                                                          : "(-" +
                                                            Math.floor(
                                                              Math.abs(
                                                                item[
                                                                  "official_punch_in_utc_datetime_save_minutes"
                                                                ]
                                                              ) / 1440
                                                            ) +
                                                            ")"
                                                        : ""
                                                    ) +
                                                    " "
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$getDateTime(
                                                          item.official_punch_in_utc_datetime_save,
                                                          "HH:mm"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-center",
                                                staticStyle: { width: "20px" },
                                              },
                                              [_vm._v("-")]
                                            ),
                                            _c(
                                              "v-sheet",
                                              {
                                                attrs: {
                                                  color:
                                                    "grey lighten-3 text-subtitle-2 text-center rounded",
                                                  width: "50%",
                                                  title: _vm.$getDateTime(
                                                    item.official_punch_out_utc_datetime_save,
                                                    "YYYY/MM/DD HH:mm"
                                                  ),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      Math.floor(
                                                        Math.abs(
                                                          item[
                                                            "official_punch_out_utc_datetime_save_minutes"
                                                          ]
                                                        ) / 1440
                                                      ) == 0
                                                        ? ""
                                                        : item[
                                                            "official_punch_out_utc_datetime_save_minutes"
                                                          ]
                                                        ? item[
                                                            "official_punch_out_utc_datetime_save_minutes"
                                                          ] > 0
                                                          ? "(+" +
                                                            Math.floor(
                                                              Math.abs(
                                                                item[
                                                                  "official_punch_out_utc_datetime_save_minutes"
                                                                ]
                                                              ) / 1440
                                                            ) +
                                                            ")"
                                                          : "(-" +
                                                            Math.floor(
                                                              Math.abs(
                                                                item[
                                                                  "official_punch_out_utc_datetime_save_minutes"
                                                                ]
                                                              ) / 1440
                                                            ) +
                                                            ")"
                                                        : ""
                                                    ) +
                                                    " "
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$getDateTime(
                                                          item.official_punch_out_utc_datetime_save,
                                                          "HH:mm"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        false
                                          ? _c(
                                              "div",
                                              { staticClass: "mt-2" },
                                              [
                                                _c(
                                                  "v-chip",
                                                  { attrs: { small: "" } },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "label_essweb_attendanceModifiApp_form_totalLabel"
                                                          )
                                                        ) +
                                                        "(" +
                                                        _vm._s(
                                                          _vm.$timeMachine(
                                                            item.official_working_minutes,
                                                            true
                                                          )
                                                        ) +
                                                        ") "
                                                    ),
                                                  ]
                                                ),
                                                Number(item.late_minutes) > 0
                                                  ? _c(
                                                      "v-chip",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "red",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "label_essweb_attendanceModifiApp_form_lateLabel"
                                                              )
                                                            ) +
                                                            "(" +
                                                            _vm._s(
                                                              _vm.$timeMachine(
                                                                item.late_minutes,
                                                                true
                                                              )
                                                            ) +
                                                            ") "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                Number(
                                                  item.early_leave_minutes
                                                ) > 0
                                                  ? _c(
                                                      "v-chip",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "red",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "label_essweb_attendanceModifiApp_form_earlyLeaveLabel"
                                                              )
                                                            ) +
                                                            "(" +
                                                            _vm._s(
                                                              _vm.$timeMachine(
                                                                item.early_leave_minutes,
                                                                true
                                                              )
                                                            ) +
                                                            ") "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                Number(item.ot_minutes_before) +
                                                Number(item.ot_minutes_after)
                                                  ? _c(
                                                      "v-chip",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "primary",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "label_essweb_attendanceModifiApp_form_otLabel"
                                                              )
                                                            ) +
                                                            "(" +
                                                            _vm._s(
                                                              _vm.$timeMachine(
                                                                Number(
                                                                  item.ot_minutes_before
                                                                ) +
                                                                  Number(
                                                                    item.ot_minutes_after
                                                                  ),
                                                                true
                                                              )
                                                            ) +
                                                            ") "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("v-spacer"),
          _vm.iSEdited
            ? _c(
                "v-sheet",
                {
                  staticClass: "align-center text-center d-flex justify-center",
                  attrs: { height: "48", width: "100%" },
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "pl-7 pr-7 text-capitalize mr-2",
                      attrs: {
                        color: "gery",
                        rounded: "",
                        text: "",
                        height: "32",
                      },
                      on: { click: _vm.closeDialog },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "label_essweb_RosterFormRecord_form_slide_form_cancelLabel"
                          )
                        )
                      ),
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "pl-7 pr-7 text-capitalize",
                      attrs: {
                        color: "primary",
                        rounded: "",
                        height: "32",
                        disabled: !_vm.curSelect,
                      },
                      on: { click: _vm.toSubmit },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "label_essweb_RosterFormRecord_form_slide_form_submitBtnLabel"
                          )
                        )
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      void 0,
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }